export default __webpack_public_path__ + "static/media/insights-yellow.a04439e2.svg";